import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CanView } from 'components/Can';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { ImportPageData } from 'components/ImportPageData';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import EmpmasterViewPage from 'pages/empmaster/View';
import GrouploancontractViewPage from 'pages/grouploancontract/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const GrouploantransactionListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		transactiondate: {
			tagTitle: $t('transactiondate'),
			value: '',
			valueType: 'single-date',
			options: [],
		},
		branchcode: {
			tagTitle: $t(''),
			value: '',
			valueType: 'single',
			options: [],
		},
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	// return sum of debit for the current records
	const totalDebit = utils.sum(records, 'debit');
	// return sum of credit for the current records
	const totalCredit = utils.sum(records, 'credit');
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/grouploantransaction/view/${data.loantransactionid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('grouploantransaction/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/grouploantransaction/edit/${data.loantransactionid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('grouploantransaction/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.loantransactionid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('grouploantransaction/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function LoantransactionidTemplate(data){
		if(data){
			return (
				<Link to={`/grouploantransaction/view/${data.loantransactionid}`}> { data.loantransactionid }</Link>
			);
		}
	}
	function LoanaccountnoTemplate(data){
		if(data){
			return (
				<>{data.loanaccountno && <Button className="p-button-text" icon="pi pi-eye" label={$t('grouploancontract')} onClick={() => app.openPageDialog(<GrouploancontractViewPage isSubPage apiPath={`/grouploancontract/view/${data.loanaccountno}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function TransactiondateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.transactiondate )}</>
			);
		}
	}
	function EmpcodeTemplate(data){
		if(data){
			return (
				<>{data.empcode && <Button className="p-button-text" icon="pi pi-eye" label={$t('empmaster')} onClick={() => app.openPageDialog(<EmpmasterViewPage isSubPage apiPath={`/empmaster/view/${data.empcode}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-grouploantransaction`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function ImportData() {
		if (props.importData) {
			return (
				<div className="m-2">
					<ImportPageData label={$t('selectAFileToImport')} uploadPath="grouploantransaction/importdata" buttonIcon="pi pi-folder" buttonLabel={$t('importData')} onImportCompleted={(response) => {app.flashMsg('Import Data', response, 'success')}} />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="grouploantransaction/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
	<CanView pagePath="grouploantransaction/importdata">
		<ImportData />
	</CanView>
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="GrouploantransactionListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('loanTransaction')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <Link to={`/grouploantransaction/add`}>
                        <Button label={$t('addNewTransaction')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={filters.transactiondate.value} onChange={(e) => setFilterValue('transactiondate', e.value)} placeholder={$t('selectDate')}   />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('branchcode', options)}  apiPath="components_data/branchcode_option_list_3"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'branchcode', e.value)} value={filters.branchcode.value} optionLabel="label" optionValue="value" options={filters.branchcode.options} placeholder={$t('selectABranch')} >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="loantransactionid" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="loantransactionid" header={$t('loantransactionid')} body={LoantransactionidTemplate} sortable={true} ></Column>
                                    <Column  field="loanaccountno" header={$t('loanaccountno')} body={LoanaccountnoTemplate} sortable={true} ></Column>
                                    <Column  field="transactiondate" header={$t('transactiondate')} body={TransactiondateTemplate} sortable={true} ></Column>
                                    <Column  field="ac_code" header={$t('acCode')}  sortable={true} ></Column>
                                    <Column  field="debit" header={$t('debit')}  sortable={true} ></Column>
                                    <Column  field="credit" header={$t('credit')}  sortable={true} ></Column>
                                    <Column  field="remarks" header={$t('remarks')}  sortable={true} ></Column>
                                    <Column  field="period" header={$t('period')}  sortable={true} ></Column>
                                    <Column  field="branchcode" header={$t('branchcode')}  sortable={true} ></Column>
                                    <Column  field="empcode" header={$t('empcode')} body={EmpcodeTemplate} sortable={true} ></Column>
                                    <Column  field="interest_yn" header={$t('interestYn')}  sortable={true} ></Column>
                                    <Column  field="ac_closed" header={$t('acClosed')}  sortable={true} ></Column>
                                    <Column  field="userid" header={$t('userid')}  sortable={true} ></Column>
                                    <Column  field="total" header={$t('total')}  sortable={true} ></Column>
                                    <Column  field="checked_yn" header={$t('checkedYn')}  sortable={true} ></Column>
                                    <Column  field="checked_by" header={$t('checkedBy')}  sortable={true} ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                                <div className="flex justify-content-around font-bold p-3">
                                    <div>Total Debit : <Chip label={totalDebit} /></div><div>Total Credit : <Chip label={totalCredit} /></div>
                                </div>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
GrouploantransactionListPage.defaultProps = {
	primaryKey: 'loantransactionid',
	pageName: 'grouploantransaction',
	apiPath: 'grouploantransaction/index',
	routeName: 'grouploantransactionlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: true,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default GrouploantransactionListPage;
